import { Logo } from "@/components/Logo";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="mt-20 border-t border-border bg-card/40 wood-grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
              A comunidade brasileira de makers e marceneiros que transformam madeira de paletes em móveis incríveis.
              Transforme madeira em ideias.
            </p>
          </div>
          <div>
            <p className="eyebrow mb-3 text-primary">Explorar</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/explorar" className="hover:text-foreground">Todos os projetos</Link></li>
              <li><Link to="/explorar?sort=popular" className="hover:text-foreground">Mais populares</Link></li>
              <li><Link to="/categorias" className="hover:text-foreground">Categorias</Link></li>
              <li><Link to="/publicar" className="hover:text-foreground">Publicar projeto</Link></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-3 text-primary">Comunidade</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/cadastro" className="hover:text-foreground">Criar conta</Link></li>
              <li><Link to="/entrar" className="hover:text-foreground">Entrar</Link></li>
              <li><span className="opacity-60">PaleteLab AI (em breve)</span></li>
              <li><Link to="/mercado" data-testid="footer-market-link" className="hover:text-foreground">Mercado</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-border pt-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} PaleteLab · Feito com madeira reaproveitada e muito carinho 🇧🇷
        </div>
      </div>
    </footer>
  );
}
